import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { Message } from 'element-ui';
import PhoneCallCom from './index.vue';
import store from '@/store';
import { cutCall } from '@/api/admissionCounseling/customerDrawerCom';
export var callVm;
export default function call(_this) {
  callVm = Message({
    dangerouslyUseHTMLString: true,
    message: _this.$createElement(PhoneCallCom),
    duration: 0,
    customClass: 'phone-call-message'
  });
}
export function handupCall() {
  return _handupCall.apply(this, arguments);
}
function _handupCall() {
  _handupCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!callVm) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return cutCall();
        case 1:
          res = _context.v;
          if (typeof res === 'string') {
            store.dispatch('resetCall');
            callVm.close();
          }
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _handupCall.apply(this, arguments);
}